import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@/lib/api/client';
import { useTenantStore } from '@/stores/tenantStore';

import type { InviteMemberInput } from '../schemas/memberSchemas';
import { memberKeys } from './memberKeys';

export function useInviteMember() {
  const qc = useQueryClient();
  const tenantId = useTenantStore((s) => s.tenantId);

  return useMutation({
    mutationFn: (body: InviteMemberInput) =>
      apiClient.post(`api/v1/t/${tenantId}/members/invite`, { json: body }).json(),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: memberKeys.lists() });
    },
  });
}
